'use client';

import { FC, use, useEffect } from 'react';

import { NormalizedEntity, NormalizedProduct } from '@ravago/shared/page-data/models/contentful-mapped';
import { RibbonContext } from '@ravago/shared/page-elements-radiance/providers/ribbon-context-providers';
import { getCountryCode } from '@ravago/shared/page-elements-radiance/utils/locale/locale.utils';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
  locale: string;
  contentType: string | undefined;
  contentEntity: NormalizedEntity | null;
}

const ProductRibbon: FC<Props> = ({ contentType, contentEntity, locale }) => {
  const translate = useTranslations();
  const { dispatch } = use(RibbonContext);

  useEffect(() => {
    if (contentType !== 'product' || !contentEntity) return;

    const country = getCountryCode(locale);
    const isoCodes = (contentEntity as NormalizedProduct).brand.countries.map((normalizedCountry) => normalizedCountry.isoCode);

    if (!isoCodes?.includes(country)) {
      dispatch({ type: 'show_ribbon', value: { variant: 'error', message: translate('page-consumer.product-detail-alert'), closable: true } });
    }
  }, []);

  return null;
};

export default ProductRibbon;
